<script setup lang="ts">
import { Dialog, DialogContent } from '~/components/ui/dialog'
import { ForgotPasswordForm } from '~/components/feature/auth'

const authModalStore = useAuthModalStore()

// Handle modal close
const handleClose = () => {
  authModalStore.closeModal()
}

const handleSuccess = () => {
  authModalStore.closeModal()
}

const switchToLogin = () => {
  authModalStore.switchToLogin()
}
</script>

<template>
  <Dialog :open="authModalStore.isForgotPasswordModalOpen" @update:open="handleClose">
    <DialogContent class="max-w-xl p-8">
      <div class="space-y-2 text-center">
        <Heading tag="h1" class="AuthHeading">
          {{ $t('feature.auth.forgot_password.title') }}
        </Heading>
        <p class="text-gray-600">{{ $t('feature.auth.forgot_password.description') }}</p>
      </div>

      <ForgotPasswordForm @success="handleSuccess" />

      <div class="text-center">
        <Button variant="outline-gray" class="w-full" @click="switchToLogin">
          {{ $t('feature.auth.forgot_password.cancel') }}
        </Button>
      </div>
      <div class="text-center text-sm text-gray-600">
        {{ $t('feature.auth.forgot_password.instructions') }}
      </div>
    </DialogContent>
  </Dialog>
</template>
